export type ProbeFanOutResult =
  | { ok: true; failures: number }
  | { ok: false; error: unknown };

export function isSalesforceReauthError(error: unknown): boolean {
  return (error as { code?: unknown } | null | undefined)?.code === 'SF_REAUTH_REQUIRED';
}

export async function probeThenFanOut<T>(
  items: readonly T[],
  send: (item: T) => Promise<unknown>,
  isFatal: (error: unknown) => boolean,
): Promise<ProbeFanOutResult> {
  if (items.length === 0) return { ok: true, failures: 0 };
  let failures = 0;
  try {
    await send(items[0]);
  } catch (error) {
    if (isFatal(error)) return { ok: false, error };
    failures += 1;
  }
  const rest = await Promise.allSettled(items.slice(1).map(send));
  return { ok: true, failures: failures + rest.filter(r => r.status === 'rejected').length };
}

export function fanOutFailureMessage(result: ProbeFanOutResult, noun: string): string | null {
  if (!result.ok) {
    return `Couldn't update ${noun}s. Check your Salesforce connection and try again. Remaining updates were not sent.`;
  }
  if (result.failures > 0) return `Failed to update ${result.failures} ${noun}(s)`;
  return null;
}
